import React, { useState } from "react";

import { Dropdown } from "antd";

import useScreenSize from "../../../utils/usescreensize";
import Searchbarloader from "../../loader/searchbarloader";

import images from "../../../assets";

import "./styles.css";

const SearchField = (props) => {
  const screenSize = useScreenSize();

  const [isLoading, setIsLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [isFocused, setIsFocused] = useState(false);

  const handleSearch = (e) => {
    setSearch(e);
  };

  const handleDropdownVisibleChange = (visible) => {
    setIsFocused(visible);
  };

  const items = [
    {
      key: "1",
      label: (
        <div className="search-content">
          {isLoading ? (
            <div style={{ margin: "0px auto", padding: "20px" }}>
              <Searchbarloader />
            </div>
          ) : (
            <h4
              style={{
                padding: "20px",
                marginBottom: "0px",
                fontSize: "16px",
                fontWeight: "500",
              }}
            >
              Search
            </h4>
          )}
        </div>
      ),
    },
  ];

  return (
    <div className="header-searchbar-container">
      <Dropdown
        menu={{
          items,
        }}
        trigger={["click"]}
        overlayStyle={{
          top:
            screenSize.width < 1023
              ? props?.promotionheader
                ? "118px"
                : "58px"
              : props?.promotionheader
              ? "120px"
              : "60px",
          borderRadius: "10px",
          borderTopRightRadius: "0px",
          borderTopLeftRadius: "0px",
          background: " #f5f6f7",
          maxWidth: "100px",
        }}
        onOpenChange={handleDropdownVisibleChange}
      >
        <div
          className={
            isFocused ? "header-searchbar-focused" : "header-searchbar"
          }
        >
          <img src={images.headerSearch} alt="search" />
          <input
            type="text"
            placeholder="Search"
            className="header-searchbar-input"
            value={search}
            onChange={(e) => handleSearch(e.target.value)}
          />
          {search && (
            <img
              src={images.clearSearchfield}
              alt="clear"
              onClick={() => setSearch("")}
            />
          )}
          {!search && isFocused && (
            <img
              src={images.searchCross}
              alt="clear"
              onClick={() => setIsFocused(false)}
            />
          )}
        </div>
      </Dropdown>
    </div>
  );
};

export default SearchField;
